import { combineReducers } from 'redux';

import isLoading from './isLoading';
import isUpdating from './isUpdating';
import selectedId from './selectedId';

/**
 * @typedef {{
 *   selectedId: string,
 *   isLoading: boolean,
 *   isUpdating: boolean,
 * }} AuditModelUIDetailsModelReducer
 */

export default combineReducers({
  selectedId,
  isLoading,
  isUpdating,
});
